import BDHelmet from '@/components/BDHelmet';

export default function UserGuide() {
	return (
		<>
			<BDHelmet title='User Guide' description='BDS Samferdsel user guide' />
			<div className='container flex flex-col gap-4 pt-8 pb-8 mx-auto'>
				<h1 className='section-title'>User Guide</h1>
				<hr />
				<h5>A. Shortcut</h5>
				<pre>How to use and where it can be used?</pre>
				<pre>1. Working on All Pages</pre>
				<pre className=''>
					<strong>a. CTRL + ALT + N </strong>(Go to page Create new project)
				</pre>
				<pre>2. Working on Detail Project Page</pre>
				<pre>
					<strong>a. CTRL + ALT + E </strong>(Go to to page Edit project)
				</pre>
				<pre>
					<strong>b. CTRL + ALT + D </strong>(Delete project)
				</pre>
				<pre>
					<strong>c. CTRL + ALT + C </strong>(Go to to page Duplicate/Copy project)
				</pre>
				<pre>
					<strong>d. CTRL + ALT + S </strong>(Share project)
				</pre>
				<pre>
					<strong>e. CTRL + ALT + Right Arrow </strong>(Go to to Next project if exist)
				</pre>
				<pre>
					<strong>f. CTRL + ALT + Left Arrow </strong>(Go to to Previous project if exist)
				</pre>
			</div>
		</>
	);
}
